import React from 'react';
import PropTypes from 'prop-types';
import I18nProvider from '@exc-ui/exc-sdk/dist/production/localization/i18n';
import TermsOfUseDialog from './TermsOfUseDialog';
import * as localizationStrings from './__localization__/TermsOfUseDialog';

function TermsOfUseDialogWrapper({ ...props }) {
  const {
    excDomian,
    touHref
  } = props;

  const localeData = {};
   Object.keys(localizationStrings).map(local => {
     const localeKey = local.replace(/_/g, '-');

     localeData[localeKey] = localizationStrings[local];
  });
  return (
    <I18nProvider autoLocale={true} localeData={localeData}>
      {<TermsOfUseDialog
          excDomian={excDomian}
          touHref={touHref}
      />}
    </I18nProvider>
  );
}

TermsOfUseDialogWrapper.displayName = 'TermsOfUseDialogWrapper';

TermsOfUseDialogWrapper.propTypes = {
  /** Experience Cloud Domain*/
  excDomian: PropTypes.string,
  /** Terms of Use page Link*/
  touHref: PropTypes.string
};

TermsOfUseDialogWrapper.defaultProps = {
  excDomian: 'https://experiencecloud.adobe.com',
  touHref: ''
};

export default TermsOfUseDialogWrapper;



// WEBPACK FOOTER //
// ./src/components/TermsOfUseDialog/TermsOfUseDialogWrapper.js